import { apiClient, getUserId } from "./authService";

interface PromoData {
  [key: string]: any;
}

export const getAllClients = async (
  businessId: string,
  venueId?: string | null
): Promise<any> => {
  try {
    if (businessId === "all") {
      if (venueId) {
        const response = await apiClient.get(`/clients/venue/${venueId}`);
        return response.data;
      }
      const userId = getUserId();
      const response = await apiClient.get(`/clients/owner/${userId}`);
      return response.data;
    } else {
      const normalizedId = String(businessId);
      const response = await apiClient.get(`/clients/${normalizedId}`);
      return response.data;
    }
  } catch (error) {
    throw error;
  }
};

// Fetch all clients associated with the admin's organization (broader than branch-level).
// Uses the admin user id from the current session.
export const getOrgClients = async (adminUserId?: string | null): Promise<any> => {
  try {
    const id = adminUserId || getUserId();
    if (!id) throw new Error("Missing admin user id for org clients fetch");
    const response = await apiClient.get(`/admins/${id}/users`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createClient = async (clientData: PromoData): Promise<any> => {
  try {
    const response = await apiClient.post("/clients/create", clientData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateClient = async (
  id: string,
  clientData: PromoData
): Promise<any> => {
  try {
    const response = await apiClient.put(`/users/edit/${id}`, clientData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getClientById = async (id: string): Promise<any> => {
  try {
    const response = await apiClient.get(`/clients/view/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteClient = async (id: string): Promise<any> => {
  try {
    const response = await apiClient.delete(`/allusers/delete/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
